import { Injectable, OnDestroy } from '@angular/core'; import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs'; import { Capacitor } from '@capacitor/core'; import { AuthHeaderService } from 'src/app/services/auth-header.service';
declare const io: any; import { TotpService } from 'src/app/services/totp.service'; import { SanctumService } from 'src/app/services/sanctum.service';
const SOCKET_IO_CDN = 'https://cdn.socket.io/4.7.4/socket.io.min.js';
function ensureSocketIo(): Promise<void> {
  if (typeof io !== 'undefined') return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SOCKET_IO_CDN}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Failed to load socket.io')));
      return;
    }
    const script = document.createElement('script');
    script.src = SOCKET_IO_CDN;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load socket.io'));
    document.head.appendChild(script);
  });
}
import { switchMap, catchError, map } from 'rxjs/operators'; import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, throwError } from 'rxjs'; import { BadgeCountService } from 'src/app/services/badge-count.service';
import { v4 as uuidv4 } from 'uuid'; import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatWebSocketService implements OnDestroy {
  private socket: any | undefined;

  constructor(
    private totpService: TotpService,
    private sanctum: SanctumService,
    private httpClient: HttpClient,
    private badgeCountService: BadgeCountService,
    private authHeaderService: AuthHeaderService
  ) {
  }

  private messagesMap = new Map<string, any[]>();
  generateUID() {
    return uuidv4();
  }
  connectedChatId: any;
  async connectSocket(chatId: string, user_chat?: string): Promise<void> {
    await ensureSocketIo();
    user_chat = localStorage.getItem('user_chat') ?? undefined;
    if (!user_chat) {
      const newUID = this.generateUID();
      localStorage.setItem('user_chat', newUID);
      user_chat = newUID;
    }

    // ✅ Verifica se já está conectado no mesmo chatId
    if (this.socket && this.connectedChatId === chatId) {
      console.log('[SOCKET] Já conectado neste chatId:', chatId);
      return;
    }

    if (this.socket) {
      console.log('[SOCKET] Encerrando conexão anterior.');
      this.socket.disconnect();
      this.socket = undefined;
    }

    this.chatId = chatId;
    this.connectedChatId = chatId;

    

    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'wss://';

    let socketHost = 'slicksell.click';
    console.log('[SOCKET] Host atual:', host);
    if (
      host.includes('stage-app.slicksell.com.br') ||
      host.includes('stage.slicksell.link')
    ) {
      socketHost = 'stage.slicksell.click';
    }
    console.log('[SOCKET] socketHost usado:', socketHost);

    // 🔹 Gera token TOTP
    // 🔹 Só tenta gerar token se for ambiente Capacitor
    let token: string | undefined = '';
    if (Capacitor.isNativePlatform()) {
      try {
        token = await this.totpService.getCurrentCode();
      } catch (err) {
        console.warn('[SOCKET] Erro ao gerar token TOTP (ignorando no web):', err);
        token = '';
      }
    }
    // 🔹 Lê user_id
    const userId = localStorage.getItem('user_id') || '';
    const isEditWidgets = window.location.pathname.includes('edit_widgets');
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const isAdmin = localStorage.getItem('ss_is_admin') === '1' ? '1' : '0';
    console.log('is_admin enviado:', isAdmin);
    console.log('[SOCKET] Iniciando conexão com parâmetros:\n' +
      JSON.stringify({
        chatId,
        user_chat,
        token,
        userId,
        store_id: storeId,
        is_admin: isAdmin,
        mobileApp: (!isEditWidgets && Capacitor.isNativePlatform()) ? 'true' : 'false'
      }, null, 2)
    );

    console.log('[SOCKET] Conectando com params:', {
      chatId,
      user_chat,
      token,
      userId,
      storeId, // <--- VEJA, NÃO 'store_id', é o valor puro
      isAdmin,
      mobileApp: (!isEditWidgets && Capacitor.isNativePlatform()) ? 'true' : 'false'
    });



    return new Promise((resolve, reject) => {
      this.socket = io(`${protocol}${socketHost}`, {
        auth: {
          chatId,                        // snake e camel
          chat_id: chatId,               // <-- pra garantir compat
          user_chat,
          token,
          userId,
          store_id: storeId,             // snake e camel
          storeId: storeId,
          is_admin: isAdmin,
          mobileApp: (!isEditWidgets && Capacitor.isNativePlatform()) ? 'true' : 'false'
        }
      });

      /////////////////////////
      // Eventos de conexão
      this.socket.on('connect', () => {
        console.log('[SOCKET] ✅ Conectado com sucesso!\n' +
          JSON.stringify({ chatId: this.chatId, socketId: this.socket.id }, null, 2)
        );
        resolve();
      });

      this.socket.on('connect_error', (err: any) => {
        console.error('[SOCKET] ❌ Falha na conexão:\n' +
          JSON.stringify({
            message: err.message,
            description: err.description || null,
            type: err.type || null
          }, null, 2)
        );
        reject(err);
      });

      this.socket.on('disconnect', (reason: string) => {
        console.warn('[SOCKET] ⚠️ Desconectado:\n' +
          JSON.stringify({ reason }, null, 2)
        );
      });

      // // Mensagens iniciais
      this.socket.on('load messages', (messages: any[]) => {
        
        this.messagesMap.set(chatId, messages);
      });
      /////////////////////////

    });
  }


  async connectSocketClean(chatId: string): Promise<void> {
    await ensureSocketIo();
    // Garante user_chat no localStorage
    let user_chat = localStorage.getItem('user_chat') ?? undefined;
    if (!user_chat) {
      user_chat = this.generateUID();
      localStorage.setItem('user_chat', user_chat);
    }

    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }

    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const isAdmin = localStorage.getItem('ss_is_admin') === '1' ? '1' : '0';
    const user_id = localStorage.getItem('user_id') || '';  // <-- PEGUE O user_id AQUI

    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    let socketHost = 'slicksell.click';
    const host = window.location.hostname;
    if (
      host.includes('stage-app.slicksell.com.br') ||
      host.includes('stage.slicksell.link')
    ) {
      socketHost = 'stage.slicksell.click';
    }

    // -- O PULO DO GATO: --
    return new Promise((resolve, reject) => {
      this.socket = io(`${protocol}${socketHost}`, {
        auth: {
          chatId,
          store_id: storeId,
          user_chat,
          is_admin: isAdmin,
          user_id    // <-- ENVIE JUNTO
        }
      });

      this.socket.on('connect', () => {
        this.socket.emit('joinAdminRoom', { user_id });
        console.log('[SOCKET] joinAdminRoom emitido', { user_id });

        this.socket.on('chat-badge-update', (messageData: any) => {
          this.badgeCountService.setUnreadCommentsCount(
            this.badgeCountService['unreadCommentsCount'] + 1 // ou recarrega do backend se preferir
          );
        });
        resolve(); // só libera depois de conectado!
      });

      this.socket.on('connect_error', (err: any) => {
        reject(err);
      });
    });
  }
  private badgeUpdate$ = new Subject<any>();

  getBadgeUpdateObservable() {
    return this.badgeUpdate$.asObservable();
  }

  connectAdminSocket(userId: string) {
    ensureSocketIo().then(() => this._connectAdminSocket(userId));
  }
  private _connectAdminSocket(userId: string) {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }
    const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    let socketHost = 'slicksell.click';
    // ... lógica de stage...
    this.socket = io(`${protocol}${socketHost}`, {
      auth: {
        is_admin: 1,
        user_id: userId
      }
    });
    //connectAdminSocket
    this.socket.on('connect', () => {
      console.log('[SOCKET][connectAdminSocket] Admin conectado!', userId);
      // badge global
      this.socket.on('chat-badge-update', (messageData: any) => {
        console.log('recebeu badge update chat-badge-update', messageData);
        this.badgeUpdate$.next(messageData);
        this.badgeCountService.setUnreadCommentsCount(
          this.badgeCountService['unreadCommentsCount'] + 1
        );
      });
    });

    this.socket.on('connect_error', (err: any) => {
      console.error('[SOCKET][connectAdminSocket] ❌ Falha na conexão:', err);
    });
  }
  username: string = '';

  getStoredMessages(chatId: string): any[] {
    return this.messagesMap.get(chatId) || [];
  }

  sendMessage(
    chatId: string,
    message: string,
    user_chat?: string,
    opts: { isAdmin?: boolean; userId?: number; username?: string } = {}
  ): void {
    user_chat = localStorage.getItem('user_chat') ?? undefined;

    if (!this.socket) {
      this.connectSocket(chatId, user_chat);
    }

    if (this.socket) {
      // deixe boolean para evitar comparações malucas
      const isAdmin = !!opts.isAdmin;

      const user_id = isAdmin ? opts.userId : undefined;

      const username = (opts.username ?? this.username) || '';

      // logs úteis
      console.log('username:', username);
      console.log('user_chat:', user_chat);
      console.log('is_admin:', isAdmin);
      console.log('user_id:', user_id);

      this.socket.emit('chat message', {
        chatId,
        content: message,
        username: username,
        user_chat: user_chat,
        // mande 1/0, mas decidido pelo boolean
        is_admin: isAdmin ? 1 : 0,
        // só “existe” se for número (se undefined, tudo ok)
        user_id
      });
    } else {
      console.log('não conectado');
    }
  }

  joinRoom(chatId: string, username: string, user_chat?: string): void {
    this.username = username; // load messages
    this.connectSocket(chatId, user_chat);

    this.socket?.emit('new user', { name: username, id: chatId, user_chat: user_chat }, (response: boolean) => {
      if (response) {
        console.log(`[SOCKET] ✅ Usuário ${username} entrou na sala ${chatId}`);
      } else {
        console.error(`[SOCKET] ❌ Falha ao entrar na sala ${chatId} para o usuário ${username}`);
      }
    });
  }

  receiveMessages(): Observable<any> {
    return new Observable(observer => {
      this.socket?.on('chat message', (message: any) => {

        //this.messagesMap.set(message.chatId, messages);
        this.addMessageToChat(message.chatId, message);
        observer.next(message);
      });
    });
  }
  addMessageToChat(chatId: string, message: any): void {
    let messages = this.messagesMap.get(chatId) || [];
    messages.push(message);
    this.messagesMap.set(chatId, messages);
  }

  removeMessageFromChat(chatId: string, messageId: any): void {
    const id = String(messageId);
    const messages = this.messagesMap.get(chatId) || [];
    const next = messages.filter(m => String(m?.id) !== id);
    this.messagesMap.set(chatId, next);
  }
  getNumUsers(chatId: string): Observable<number> {
    this.connectSocket(chatId); // Desliga o ouvinte anterior para evitar múltiplas respostas
    return new Observable(observer => {
      this.socket?.on('num users', (numUsers: number) => {
        observer.next(numUsers);
      });
    });
  }

  chatId: string = '';

  getInitialMessages(chatId: string, opts: { refresh?: boolean } = {}): Observable<any[]> {
    if (!chatId) return new Observable(obs => obs.next([]));
    const refresh = !!opts.refresh;

    let cached = this.messagesMap.get(chatId) || [];

    return new Observable(observer => {
      const localUserIp = localStorage.getItem('user_chat') || '';

      const normalize = (arr: any[]) =>
        (arr || [])
          .map(m => {
            // preferir created_at vindo do backend; só “promove” se vier sem TZ
            let created = m.created_at || m.time || new Date().toISOString();
            if (typeof created === 'string') {
              created = created.trim();
              if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/.test(created)) {
                created = created.replace(' ', 'T');
              }
              created = created.replace(/\.(\d{3})\d+(?=([Zz]|[+\-]\d{2}:?\d{2})?$)/, '.$1');
              if (!/[Zz]|[+\-]\d{2}:?\d{2}$/.test(created)) {
                created = `${created}Z`;
              }
            }
            let createdDate = new Date(created);
            if (!isNaN(createdDate.getTime()) && createdDate.getTime() - Date.now() > 60_000) {
              createdDate = new Date(createdDate.getTime() - 3 * 60 * 60 * 1000);
            }
            const created_at = isNaN(createdDate.getTime()) ? new Date().toISOString() : createdDate.toISOString();
            const ip = String(m.ip ?? m.user_chat_id ?? m.from_id ?? '');
            const sender =
              m.from ??
              m.from_name ??
              m.sender_name ??
              m.username ??
              m.store_name ??
              '';

            if (!!m?.is_admin && !String(sender).trim()) {
              // Log direcionado: ajuda a confirmar se o backend está enviando sender_name/username/store_name
              // sem poluir o console para mensagens normais.
              // eslint-disable-next-line no-console
              console.warn('[chat] admin message without sender name:', {
                id: m?.id,
                from: m?.from,
                from_name: m?.from_name,
                sender_name: m?.sender_name,
                username: m?.username,
                store_name: m?.store_name,
                user_chat_id: m?.user_chat_id,
                from_id: m?.from_id,
                ip: m?.ip,
                created_at: m?.created_at
              });
            }

            return {
              ...m,
              ip,
              created_at,
              text: m.text ?? m.content ?? '',
              from: sender,
              isOwnMessage: ip === localUserIp
            };
          })
          .sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));

      const dedupe = (arr: any[]) => {
        const seen = new Set<string>();
        const out: any[] = [];
        for (const m of arr || []) {
          const key =
            m?.id != null
              ? `id:${String(m.id)}`
              : `k:${String(m?.ip ?? '')}|${String(m?.created_at ?? '')}|${String(m?.text ?? '')}`;
          if (seen.has(key)) continue;
          seen.add(key);
          out.push(m);
        }
        return out;
      };

      // 1) emite cache atual (a UI não fica “em branco”)
      if (!refresh && cached.length) {
        cached = dedupe(normalize(cached));
        observer.next([...cached]);
      }

      // 2) SEMPRE pede atualização ao servidor
      this.socket?.emit('getMessages', chatId);

      // 3) evita múltiplos handlers (muito importante)
      this.socket?.off?.('messages'); // se sua versão tiver off
      // ou: this.socket?.removeAllListeners?.('messages');

      // 4) ouve UMA vez a resposta e finaliza
      this.socket?.on('messages', (payload: any) => {
        const rawMessages = payload?.messages ?? [];
        // eslint-disable-next-line no-console
        console.log('[chat] messages payload sample:', {
          chatId,
          total: payload?.total,
          sample: Array.isArray(rawMessages) ? rawMessages.slice(0, 15): rawMessages
        });
        const incoming = dedupe(normalize(rawMessages));
        const base = refresh ? incoming : [...(cached || []), ...incoming];
        const updated = dedupe(normalize(base));

        this.messagesMap.set(chatId, updated);
        observer.next([...updated]);
        observer.complete();
      });
    });
  }

  receiveInitialMessages(): Observable<any[]> {
    return new Observable(observer => {
      this.socket?.on('messages', (messages: any[]) => {
        console.log('📩 [receiveInitialMessages] Mensagens recebidas (on):', messages);
        observer.next(messages);
      });
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;  // Limpa a instância após desconectar
    }
    this.cleanupSocket();

    // Limpa o cache de mensagens!
    if (this.messagesMap) {
      this.messagesMap.clear();
    }
  }
  ngOnDestroy(): void {
    console.log('ChatWebSocketService destruído. Encerrando WebSocket.');
    this.cleanupSocket(); // Certifique-se de limpar o WebSocket
  }
  private cleanupSocket(): void {
    if (this.socket) {
      console.log('Encerrando conexões e removendo listeners do WebSocket.');

      // Remover todos os listeners do WebSocket
      this.socket.off('connect');
      this.socket.off('connect_error');
      this.socket.off('disconnect');
      this.socket.off('load messages');
      this.socket.off('chat message');
      this.socket.off('num users');
      this.socket.off('messages');

      // Desconectar o WebSocket
      this.socket.disconnect();
      this.socket = undefined; // Limpa a instância do socket
    }
  }


  // chat-web-socket.service.ts (ou equivalente)
  answerChat(replyToId: number, replyContent: string, roomUniqId: string, user_chat_id: string): Observable<any> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${selectedStoreId}/answer_chat/${replyToId}`;
    const payload = {
      reply_content: replyContent,
      user_chat_id: user_chat_id,
      reply_to_id: replyToId,
      room_uniq_id: roomUniqId // <-- NOVO campo
    };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post(url, payload, httpOptions).pipe(
              catchError((error) => throwError(() => error))
            )
          )
        )
      )
    );
  }


  sendAdminMessage(content: string, roomUniqId: string): Observable<any> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${selectedStoreId}/chat/${roomUniqId}/send_message`;
    const payload = { content };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post(url, payload, httpOptions).pipe(
              catchError((error) => throwError(() => error))
            )
          )
        )
      )
    );
  }

  removeMessage(messageId: number): Observable<any> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${selectedStoreId}/remove_chat_message/${messageId}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.delete(url, httpOptions).pipe(
              catchError((error) => throwError(() => error))
            )
          )
        )
      )
    );
  }

}

